module.exports = __webpack_public_path__ + "media/assets/images/category/StPatrickssDay@2x-7da68d4f63220563b1ffb0e7175f7845.png";